import React, {Component} from 'react';
import ClientProgress from "../components/dashboard/ClientProgress";
import AuthProvider from "../providers/AuthProvider";
import { Button } from "@mui/material";
import Dashboard from "./dashboards/PerformanceDashboard";
import CurrentClientProvider from "../providers/CurrentClientProvider";
import CrossClientDashboard from "./dashboards/CrossClientDashboard";
import CrossClientDashboardV3 from "./dashboards/v3/CrossClientDashboardV3";

// Admin and Support role IDs from backend
const ADMIN_ROLE_ID = 'd76bf050-3555-4a15-8e0a-3f6c57eb31a7';
const SUPPORT_ROLE_ID = '8741bc0d-6bd5-4bdf-9b33-52fe9f25bf91';

function Home(props) {
    // Home.js is rendered both as the legacy fallback (via DashboardHomeEntryRoute,
    // no prop passed, always legacy) and directly as the real /v3/home route
    // (App.js passes visualVariant="v3"). It must never guess its mode from the
    // URL - the caller is required to be explicit so the legacy/v3 cross-client
    // dashboards can never leak into one another.
    const isV3 = props?.visualVariant === 'v3'
    const CrossClientDashboardComponent = isV3 ? CrossClientDashboardV3 : CrossClientDashboard
    const auth = AuthProvider.useAuth()
    const [showNewExperience, setShowNewExperience] = React.useState(false)
    const [showClientProgress, setShowClientProgress] = React.useState(false)
    const currentClient = CurrentClientProvider.useClient()
    const typeformInitialized = React.useRef(false);


    // Check if user is admin or developer (support role)
    const isAdminOrDeveloper = React.useMemo(() => {
        if (!auth.user || !auth.user.roles) return false;
        return auth.user.roles.some(role =>
            role.id === ADMIN_ROLE_ID || role.id === SUPPORT_ROLE_ID
        );
    }, [auth.user]);

    // In development, show toggle to everyone for testing
    // In production, show toggle only to admins/developers
    const isDevelopment = process.env.NODE_ENV === 'development' || window.location.hostname === 'localhost';
    const shouldShowToggle = isDevelopment || isAdminOrDeveloper;


    React.useEffect(() => {
        document.title = 'Retail ORBIT: Home'

        return () => {
            setShowNewExperience(false)
        }
    }, [])


    // Typeform script handling
    React.useEffect(() => {
        if (currentClient.client && currentClient.client.Id) {
            const clientId = parseInt(currentClient.client.Id);
            setShowNewExperience(false);
        }
    }, [currentClient.client])

    // Typeform script handling - only load when showNewExperience is true
    React.useEffect(() => {
        if (!showNewExperience) {
            // Don't load typeform if not showing new experience
            return;
        }

        // Create script element
        const script = document.createElement('script');
        script.src = "//embed.typeform.com/next/embed.js";
        script.async = true;
        
        // Function to initialize Typeform after script loads
        script.onload = () => {
            if (window.tf && !typeformInitialized.current) {
                // Force Typeform to scan for elements with data-tf-* attributes
                window.tf.load();
                typeformInitialized.current = true;
            }
        };
        
        // Append script to document
        document.body.appendChild(script);
        
        // Cleanup function to remove script when component unmounts
        return () => {
            if (document.body.contains(script)) {
                document.body.removeChild(script);
            }
            typeformInitialized.current = false;
        };
    }, [showNewExperience]);

    // Dedicated TypeForm feedback button component
    const TypeformFeedbackButton = () => {
        return (
            <div 
                className="fixed bottom-4 right-4 z-50"
                data-tf-live="01JT65AY4DKD6G9RNVBC65RAX3"
            ></div>
        );
    };

    return (
        <>
            {/* {currentClient.client && currentClient.client.Id ?
                <button
                    onClick={() => {
                    setShowNewExperience(!showNewExperience)
                    }}
                    className="mb-2 mt-2 bg-green-600 hover:bg-green-500 text-white px-4 py-2 rounded"
                >
                    {showNewExperience ? 'Return to Classic Dashboard' : 'Show New Dashboard'}
                </button>
                : null} */}
            {showNewExperience ? (
                <>
                    <CrossClientDashboardComponent />
                    <TypeformFeedbackButton />
                </>
            ) : showClientProgress ? (
                <ClientProgress onToggleBack={() => setShowClientProgress(false)} />
            ) : (
                <CrossClientDashboardComponent onToggleSingleClient={(shouldShow) => setShowClientProgress(shouldShow)} />
            )}
        </>
    )
}

export default Home